"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveHideRating = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
const resolveHideRating = async ({
  staticApiUrl,
  tenant,
  logger
}) => {
  const client = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl
  });
  try {
    const {
      data: {
        isRatingsAndReviewsEnabled
      }
    } = await (0, _staticApiClientReact.getTenantApplicationsProductboxConfiguration)(client, tenant);
    return !isRatingsAndReviewsEnabled;
  } catch (error) {
    if (logger) {
      logger.error(new Error('Failed getTenantTestfreaksConfiguration in resolveHideRating', {
        cause: error
      }));
    }
    return true;
  }
};
exports.resolveHideRating = resolveHideRating;
